var e=function(e){var t=e.slice().sort((function(e,t){return new Date(e.day).getTime()-new Date(t.day).getTime()}));return[t[0],t[t.length-1]]};export{e as getMinMaxDates};
